export default {
    name: "auth",
    component: () => import(/* auth-router-module */ '@/layouts/BlankLayout.vue'),
    children: [
        {
            path: "",
            name: "login",
            meta: {
                breadcrumbs: [],
                title: "Login"
            },
            component: () => import('@/modules/auth/views/Login.vue')
        }
    ]
}